export enum AssignmentStatusOptions {
  ASSIGNED = '979d841e-a0c5-4359-a83b-4982c888f48f',
  COMPLETE = '0d0287e9-25b6-4da1-b02d-84b5813b69dd',
  REJECTED = '52878246-862e-4c71-afe7-186c1c16d1dc',
  CANCEL = '247f4545-e600-4d56-b9f5-8e84e68ca335',
  SERIES_CANCELLED = 'f678cbb6-a9dd-468c-83f5-56f8d6532116'
}
